export default __webpack_public_path__ + "static/media/items-catalogue.0a5533b7.png";